var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666748 8.66658L0.666748 9.33325C0.666748 10.4378 1.56218 11.3333 2.66675 11.3333L9.33341 11.3333C10.438 11.3333 11.3334 10.4378 11.3334 9.33325L11.3334 8.66658M8.66675 5.99992L6.00008 8.66658M6.00008 8.66658L3.33341 5.99992M6.00008 8.66658L6.00008 0.666584",
    stroke: "#F9B120",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.44edcd5ab4dc86520f10ba4335277d93.svg";
export { ForwardRef as ReactComponent };